import { OpenDialogButton } from '@/components/ConsoleDialog/handlers'
import { PlatformDependent } from '@/components/PlatformDependent'

import { type GeoBlockingFormProps, GeoBlockingTemplateForm } from './GeoBlockingTemplateForm'
export { GeoBlockingTemplateCountryAutocomplete as CountryAutocomplete } from './GeoBlockingTemplateCountryAutocomplete'
export type { GeoBlockingFormProps } from './GeoBlockingTemplateForm'
export { GeoBlockingTemplateForm } from './GeoBlockingTemplateForm'
export * from './GeoBlockingTemplateForm.constants'
export { SelectedRegionsChips } from './SelectedRegionsChips'

export const GeoBlockingTemplateFormButton = (props: GeoBlockingFormProps) => (
  <PlatformDependent streaming>
    <OpenDialogButton label="Add Geo Template">
      <GeoBlockingTemplateForm {...props} />
    </OpenDialogButton>
  </PlatformDependent>
)
